import React, { Fragment } from 'react';
import Timer from 'react-compound-timer';
import classes from './promoBar.css';
import { useIntl } from 'react-intl';
var PromoBarTimer = _ref => {
  var {
    dateEnd,
    dateNow
  } = _ref;
  // Function to calulcate the end date of the promo and return it into ms for the countdown
  var counterValue = () => {
    return dateEnd - dateNow;
  };
  var {
    formatMessage
  } = useIntl();
  var countDownData = [{
    time: formatMessage({
      defaultMessage: 'Days',
      id: 'Days'
    }),
    countDown: /*#__PURE__*/React.createElement(Timer.Days, null),
    colon: ':'
  }, {
    time: formatMessage({
      defaultMessage: 'Hours',
      id: 'Hours'
    }),
    countDown: /*#__PURE__*/React.createElement(Timer.Hours, null),
    colon: ':'
  }, {
    time: 'Minutes',
    countDown: /*#__PURE__*/React.createElement(Timer.Minutes, null),
    colon: ':'
  }, {
    time: formatMessage({
      defaultMessage: 'Seconds',
      id: 'Seconds'
    }),
    countDown: /*#__PURE__*/React.createElement(Timer.Seconds, null)
  }];
  return /*#__PURE__*/React.createElement(Timer, {
    initialTime: counterValue(),
    direction: "backward"
  }, () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.promoBarCountdownContrainer
  }, countDownData.map((i, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: "".concat(i.time, "-").concat(index)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.promoBarCountdown
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.promoBarTime
  }, i.countDown), /*#__PURE__*/React.createElement("span", {
    className: classes.promoBarDays
  }, i.time)), /*#__PURE__*/React.createElement("div", {
    className: classes.promoBarColon
  }, /*#__PURE__*/React.createElement("span", null, i.colon)))))));
};
export default PromoBarTimer;